import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Select, message, Spin, Image, Button } from 'antd';
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import verizon_logo from "../../images/verizon_logo.png"
import { AppstoreOutlined } from '@ant-design/icons';
import { MsalLogin } from "../../services/msal"

export default function Login() {
    const handleLogin = async () => {
        try {
            let loginResp = await MsalLogin();

            if(loginResp) {
                const { access_token_global } = loginResp;

                localStorage.setItem("token", access_token_global);
                delete loginResp.access_token_global;
                localStorage.setItem("user", JSON.stringify(loginResp));
                localStorage.setItem("isLoggedIn", true)
                message.success("Login successful");

                window.location.href = window.location.origin + '/dashboard';
            }

        } catch (err) {
            return message.error("Login Failed!!")
        };
    };

    return (

        <div className="auth-wrapper">
            <div className="auth-inner">
                <div className='d-flex justify-content-center align-items-center'>
                    <Image width={150} className="py-5" preview={false} src={verizon_logo} />
                </div>
                <>
                    <h3 className='p-0'>Login:</h3>
                    <small className='d-block '>Please use your microsoft account to login</small>
                    <Button className='my-3 cyan' block onClick={(e) => handleLogin()}>Microsoft Login</Button>
                </>
            </div>
        </div>

    );
}